import { QuestionsService } from '../../services/questionsService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { Question } from '../../models/question';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-update-question',
  templateUrl: './update-question.component.html',
  styleUrls: ['./update-question.component.css'],
})
export class UpdateQuestionComponent implements OnInit {
  question: Question;
  serviceId: number;
  questionId: number;
  isLoading: boolean = false;
  constructor(
    private diag: NbDialogRef<UpdateQuestionComponent>,
    private service: QuestionsService,
    private toast: NbToastrService,
    private route: Router
  ) {
    this.question = {} as Question;
  }

  ngOnInit(): void {
    this.route.events.subscribe(() => {
      this.diag.close('false');
    });
    // this.service.getById(this.questionId).subscribe((res) => {
    //   this.question = res;
    // });
  }
  add() {
    this.isLoading = true;
    if (this.serviceId != null && this.serviceId !== 0) this.question.serviceId = this.serviceId;
    this.service.put(this.question.id, this.question).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم تعديل السؤال بنجاح', '', { status: 'success', duration: 3000 });
      this.diag.close('true');
    });
  }

  closePopup() {
    this.diag.close('false');
  }
}
